"use client"
import AppLayout from "../../templates/AppLayout";
import TermsconditionOrganism from "../../organisms/Termscondition/index";

const TermsConditionPage = () => {
  return (
    <AppLayout>
      <main className="bg-background text-on-surface font-body">
        
        <TermsconditionOrganism />
      </main>
    </AppLayout>
  );
};

export default TermsConditionPage;